export { default } from "./InteractiveMultipleChoice";
